export function buildDashPath({
  params,
  nextPath,
}: {
  params: any;
  nextPath: string;
}) {
  if (params.organizationId) {
    return `/dashboard/organizations/${params.organizationId}/${nextPath}`;
  }

  return `/dashboard/${nextPath}`;
}
